import React from 'react';
import { useMutation } from 'react-query';

import { FeedbackDialogUI } from './feedback-dialog-ui';

export type FeedbackDialogProps = {
  visible: boolean;
  onClose: (message?: string) => void;
  onSubmit: (message: string) => Promise<any>;
  successNode?: React.ReactNode;
  nlsKeys: {
    title: string;
    instructions: string;
    enterText: string;
    newQuestion?: string;
  };
};

export function FeedbackDialog({ onSubmit, ...props }: FeedbackDialogProps) {
  const {
    mutate: submit,
    reset,
    isLoading,
    isSuccess,
    isError,
  } = useMutation<Response, unknown, string, unknown>((message) =>
    onSubmit(message)
  );

  return (
    <FeedbackDialogUI
      isError={isError}
      isLoading={isLoading}
      isSuccess={isSuccess}
      onReset={reset}
      onSubmit={submit}
      {...props}
    />
  );
}
